import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { toast } from "sonner";
import { Mail, ArrowLeft, CheckCircle } from "lucide-react";

const API = `${window.location.origin}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Email inviata!");
    } catch (error) {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen hero-gradient flex items-center justify-center p-4" data-testid="forgot-password-page">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-wellness-31/artifacts/42tsb1mv_PdfImage.png"
              alt="ODR Accademia"
              className="h-24 mx-auto mb-4"
            />
          </div>

          <Card className="rounded-2xl shadow-xl border-border/50">
            <CardContent className="pt-8 pb-8 text-center">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="font-serif text-xl font-semibold mb-2">Email Inviata!</h2>
              <p className="text-muted-foreground mb-6">
                Se l'indirizzo <strong>{email}</strong> è registrato, riceverai un'email con il link per reimpostare la password.
              </p>
              <p className="text-sm text-muted-foreground mb-6">
                Controlla anche la cartella spam.
              </p>
              <Link to="/login">
                <Button variant="outline" className="rounded-full">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Torna al Login
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen hero-gradient flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_beauty-wellness-31/artifacts/42tsb1mv_PdfImage.png"
            alt="ODR Accademia"
            className="h-24 mx-auto mb-4"
          />
          <h1 className="font-serif text-2xl font-semibold text-[#B87A8A]">La Bellezza che Cura</h1>
        </div>

        <Card className="rounded-2xl shadow-xl border-border/50">
          <CardHeader className="text-center pb-2">
            <CardTitle className="font-serif text-2xl">Password Dimenticata?</CardTitle>
            <CardDescription>
              Inserisci la tua email e ti invieremo un link per reimpostare la password
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="nome@esempio.it"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="rounded-xl"
                  data-testid="forgot-email-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full rounded-full btn-shine"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Invio in corso...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    Invia Link di Reset
                  </span>
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <Link
                to="/login"
                className="text-sm text-muted-foreground hover:text-primary flex items-center justify-center gap-1"
              >
                <ArrowLeft className="w-3 h-3" />
                Torna al Login
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
